
import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Box, Alert, CircularProgress } from '@mui/material';
import { COLLEGE_SEMESTERS } from '../../utils/semesterDefaults';

export default function Studentcheckatt() {
    const [attendance] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState('');
    const [selectedSubject, setSelectedSubject] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [semesters, setSemesters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                setLoading(true);
                const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));

                if (!loggedUser || !loggedUser.institution_id) {
                    setError('Session expired. Please login again.');
                    return;
                }
                
                // Fetch semesters from subjects
                const subjectsRef = collection(db, 'institutions', loggedUser.institution_id, 'subjects');
                const subjectsSnapshot = await getDocs(subjectsRef);
                
                if (subjectsSnapshot.empty) {
                    setSemesters(COLLEGE_SEMESTERS);
                } else {
                    const uniqueSemesters = [...new Set(subjectsSnapshot.docs.map(doc => doc.data().semester))];
                    setSemesters(uniqueSemesters.length > 0 ? uniqueSemesters : COLLEGE_SEMESTERS);
                }
                setError('');
            } catch (error) {
                console.error('Error fetching initial data:', error);
                setError('Failed to load attendance data. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);

    useEffect(() => {
        if (selectedSemester) {
            const fetchSubjects = async () => {
                try {
                    const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
                    const q = query(
                        collection(db, 'institutions', loggedUser.institution_id, 'subjects'),
                        where('semester', '==', selectedSemester)
                    );
                    const snapshot = await getDocs(q);
                    const subjectsData = snapshot.docs.map(doc => ({
                        id: doc.id,
                        name: doc.data().name || doc.data().subject_name
                    }));
                    setSubjects(subjectsData);
                    setError('');
                } catch (error) {
                    console.error('Error fetching subjects:', error);
                    setError('Failed to load subjects. Please try again.');
                }
            };
            fetchSubjects();
        }
    }, [selectedSemester]);

    return (
        <Layout>
            {error && <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>}
            {loading && <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>}
            <div className='col-12'>
                <div className='row'>
                    <h1 className='col-12 mb-5'>Check Your Attendance</h1>
                    <div className='form-floating col-sm-3'>
                        <select className='form-select' value={selectedSemester} onChange={(e) => setSelectedSemester(e.target.value)}>
                            <option value=''>Select Semester</option>
                            {semesters.map((sem) => (
                                <option key={sem} value={sem}>{sem}</option>
                            ))}
                        </select>
                        <label className='ms-3'>Semester</label>
                    </div>
                    {subjects.length > 0 ? (
                        <div className="form-group form-floating ms-3 col-5">
                            <select required id="subject floatingSelect" className="form-select" aria-label="Floating label select example" value={selectedSubject} onChange={
                                (e) => setSelectedSubject(e.target.value)
                            } >
                                <option value="">
                                    -----------
                                </option>
                                {subjects.map((subject) => (
                                    <option key={subject.id} value={subject.name}>
                                        {subject.name}
                                    </option>
                                ))}
                            </select>
                            <label htmlFor="floatingSelect">Select Subject:</label>
                        </div>
                    ) : semesters.length > 0 && (selectedSemester == null || selectedSemester === '') ? (
                        <p className="text-info-emphasis p-3">Select Semester to view subjects</p>
                    ) : null}
                    <h3 className='mt-5 mb-5'>Attendance</h3>
                    <table className='table table-hover col-4'>
                        <thead>
                            <tr>
                                <th scope='col'>Date</th>
                                <th scope='col'>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attendance.length > 0 ? (
                                attendance.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{entry.date}</td>
                                        <td className={entry.Status === 'A' ? 'text-danger' : 'text-success'}>
                                            {entry.Status}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan='2' className='text-center'>No records found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>
            </div>
        </Layout>
    );
}
